export var exportTypes = {
    txt: 'txt',
    css: 'css',
    html: 'html',
    json: 'json',
    csv: 'csv',
    xls: 'xls',
    xml: 'xml',
};



//////////////////
// WEBPACK FOOTER
// ./~/export-from-json/dist/esm/types.js
// module id = 593
// module chunks = 0